import axios from "axios";
import {TOKEN_NAME} from "../shared/utils/constants/storage";
import {handleUnauthorizedError} from "../shared/utils/axiosUtils";

export const getBaseUrl = () => {
    return `https://${window.location.hostname}:8443`;
};

export const API_DRIVER = axios.create({
    baseURL: getBaseUrl(),
    responseType: "json",
    headers: {
        "Content-Type": "application/json"
    }
});

API_DRIVER.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem(TOKEN_NAME);
        if (token) {
            config.headers.Authorization = `${token}`;
        }
        return config;
    },
    error => Promise.reject(error)
);


API_DRIVER.interceptors.response.use(
    response => {
        if (response.headers['content-type'] && response.headers['content-type'].includes('text/html')) {
            return
        }
        return response
    },
    error => {
        handleUnauthorizedError(error);
        return Promise.reject(error);
    }
);
